import { ChangeEventHandler, useMemo } from "react";
import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import RefundCalculatorSelect from "./RefundCalculatorSelect";

interface RefundCalculatorPaymentDateSelectProps {
  id: string;
  label: string;
  sangjoId: keyof typeof SANGJO_PRODUCTS | "";
  sangjoProductId: string;
  paymentsCount: string;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const RefundCalculatorPaymentDateSelect = ({
  id,
  label,
  sangjoId,
  sangjoProductId,
  paymentsCount,
  onChange,
}: RefundCalculatorPaymentDateSelectProps) => {
  const sangjoProducts = sangjoId ? SANGJO_PRODUCTS[sangjoId] : [];

  const selectedSangjoProduct = sangjoProducts
    ? sangjoProducts.find((product) => product.id === Number(sangjoProductId))
    : undefined;

  const 비정기상조납입기간SelectItems = () => {
    const 납입기간배열 = selectedSangjoProduct?.비정기_납입기간
      .split("+")
      .map((value) => Number(value.trim()));
    const total = 납입기간배열?.reduce((acc, cur) => (acc += cur));

    return Array.from({ length: Number(total) }, (_, index) => {
      const month = index + 1;

      return {
        text: month + " 개월",
        value: month,
      };
    });
  };

  const sangjoProductPaymentDateSelectItems = useMemo(() => {
    if (selectedSangjoProduct?.paymentType === "정기형") {
      return Array.from(
        { length: Number(selectedSangjoProduct?.totalPaymentDates) || 0 },
        (_, index) => {
          const month = index + 1;

          return {
            text: month + " 개월",
            value: month,
          };
        },
      );
    }

    if (selectedSangjoProduct?.paymentType === "비정기형") {
      return 비정기상조납입기간SelectItems();
    }
  }, [sangjoId, sangjoProductId]);

  return (
    <RefundCalculatorSelect
      id={id}
      label={label}
      value={paymentsCount}
      items={sangjoProductPaymentDateSelectItems}
      onChange={onChange}
    />
  );
};
